/* SafeMarket Landing — Shared Animation Observer */
(function () {
  'use strict';

  var THRESHOLD = 0.15;
  var ROOT_MARGIN = '0px 0px -40px 0px';
  var SELECTOR = '[class*="sl-anim-fade"], .sl-anim-stagger, .sl-anim-cascade, .sl-anim-wave-bg';
  var VISIBLE_CLASS = 'sl-anim-visible';

  function shouldAnimate() {
    return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initObserver(scope) {
    if (!shouldAnimate()) return;

    var elements = (scope || document).querySelectorAll(SELECTOR);
    if (!elements.length) return;

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          var el = entries[i].target;
          if (!el.closest('[data-sl-no-anim]')) {
            el.classList.add(VISIBLE_CLASS);
          }
          observer.unobserve(el);
        }
      }
    }, { threshold: THRESHOLD, rootMargin: ROOT_MARGIN });

    for (var j = 0; j < elements.length; j++) {
      if (!elements[j].classList.contains(VISIBLE_CLASS)) {
        observer.observe(elements[j]);
      }
    }
  }

  /* --- Wave cutout enter animation --- */
  var WAVE_SELECTOR = '.sl-wave-cutout';
  var WAVE_ANIMATE_CLASS = 'sl-wave-animate';
  var WAVE_DURATION = 3000; /* ms — matches CSS wave ripple animation + buffer */

  function initWaveObserver(scope) {
    if (!shouldAnimate()) return;

    var waves = (scope || document).querySelectorAll(WAVE_SELECTOR);
    if (!waves.length) return;

    var waveObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          var el = entries[i].target;
          if (!el.closest('[data-sl-no-anim]')) {
            el.classList.add(WAVE_ANIMATE_CLASS);
            /* Remove class after animation completes so it doesn't replay */
            (function (element) {
              setTimeout(function () {
                element.classList.remove(WAVE_ANIMATE_CLASS);
              }, WAVE_DURATION);
            })(el);
          }
          waveObserver.unobserve(el);
        }
      }
    }, { threshold: THRESHOLD, rootMargin: ROOT_MARGIN });

    for (var k = 0; k < waves.length; k++) {
      waveObserver.observe(waves[k]);
    }
  }

  /* Init on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initObserver();
      initWaveObserver();
    });
  } else {
    initObserver();
    initWaveObserver();
  }

  /* Re-init on Shopify theme editor section reload */
  document.addEventListener('shopify:section:load', function (e) {
    initObserver(e.target);
    initWaveObserver(e.target);
  });
})();
